import { Toro } from '../common/enumerations';
import { OrganizationAdministered } from './organization-administered.model';
import { OrganizationRepresented } from './organization-represented.model';
import { PaginationMetaData } from './pagination-meta-data.model';
import { ToroAccountSimple } from './toro-account-simple.model';

export class UsersResponse {
    public Users: UserListItem[];
    public PaginationMetaData: PaginationMetaData;
}

export class UserListItem{
    public Email: string;
    public FName: string;
    public Id: number;
    public IsToroAdministrator: boolean;
    public LName: string;
    public WhenCreated: string;
    public WhenLastUpdated: string;
    public WhenTokenIssued: string;
}

export class User
{

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.AccountsAdministered)
            {
                this.AccountsAdministered = [];
                json.AccountsAdministered.forEach(account =>
                {
                    this.AccountsAdministered.push(new ToroAccountSimple(Toro.AccountType.Administered, account));
                });
            }

            if (json.AccountsRepresenting)
            {
                this.AccountsRepresenting = [];
                json.AccountsRepresenting.forEach(account =>
                {
                    this.AccountsRepresenting.push(new ToroAccountSimple(Toro.AccountType.Representing, account));
                });
            }
        }
    }

    public Email: string;
    public FName: string;
    public Id: number;
    public IsToroAdministrator: boolean;
    public LName: string;
    public OrganizationsAdministered: OrganizationAdministered[];
    public OrganizationsRepresented: OrganizationRepresented[];
    public Password: string;
    public SecretId: string;
    public Token: string;
    public WhenCreated: string;
    public WhenLastUpdated: string;
    public WhenTokenIssued: string;

    public AccountsAdministered: ToroAccountSimple[];
    public AccountsRepresenting: ToroAccountSimple[];

}


